import React, { useCallback } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { useLeadDuplicateQuery } from 'api/leadDuplicates';

// components
import DuplicateLeads from './DuplicateLeads';
import { Box, Paper } from '@material-ui/core';

export default function LeadDuplicateView() {
  const { leadDuplicateId: leadDuplicateIdParam } = useParams<{
    leadDuplicateId: string;
  }>();
  const navigate = useNavigate();
  const { data: leads = [], isLoading } = useLeadDuplicateQuery(
    Number(leadDuplicateIdParam)
  );
  const handleDelete = useCallback(() => {
    navigate('/leads');
  }, [navigate]);
  return (
    <Box
      marginY={3}
      padding={3}
      width='fill-available'
      height='max-content'
      minHeight='calc(100% - 48px)'
      display='flex'
      clone
    >
      <Paper>
        <DuplicateLeads
          leads={leads}
          isLeadsLoading={isLoading}
          onDelete={handleDelete}
        />
      </Paper>
    </Box>
  );
}
